import { defineAction } from '~/prix'
import residenceExportAction from './residenceExport.action.json' with { type: 'json' }
import { z } from 'zod'

export const residenceExportFormatSchema = z.enum(['gpx', 'kml', 'kmz', 'csv']).default('gpx')
export const residenceExportScopeSchema = z.enum(['all', 'rural']).default('all')

const residenceExportDefinition = defineAction({
  ...residenceExportAction,

  input: z.object({
    format: residenceExportFormatSchema,
    scope: residenceExportScopeSchema,
  }),
  output: z.any(),
})

export default residenceExportDefinition
